import { useEffect, useState } from "react"
import _ from 'lodash'
import { connect } from "react-redux"
import UsageAndMetrics from "./UsageAndMetrics"
import { accountService } from "../../../Services/AccountService/AccountService"
import Error404 from "../../ErrorPages/Error404"
import { Loader } from "../../../Components"

const ApiUsageAndMetrics = (props) => {
  const [showMetrics, setShowMetrics] = useState(props.isSuperAdmin)
  const [loading, setLoading] = useState(!(props.isSuperAdmin || props.isViewOnly))

  const getAccountDetails = () => {
    setLoading(true)
    const params = { account_id: props.currentUser.account_id }
    accountService.getAccountDetails(params)
      .then(accountData => {
        setLoading(false)
        setShowMetrics(_.get(accountData, 'account.api_usage_and_metrics_enabled', false))
      })
      .catch(error => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (!(props.isSuperAdmin || props.isViewOnly) && props.currentUser)
      getAccountDetails()
  }, [props.isSuperAdmin, props.isViewOnly, props.currentUser])

  return (
    !loading ? showMetrics ? <UsageAndMetrics /> : <Error404 /> : <Loader loading={loading} />
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin, isViewOnly, accountId } = auth
  return { currentUser, isSuperAdmin, isViewOnly, accountId }
}

export default connect(mapStateToProps, {})(ApiUsageAndMetrics)